import { useMutation, gql } from "@apollo/client"
import { GROUP_FIELDS } from "./useQueryGroups"

const UPDATE_GROUP_MUTATION = gql`
  mutation UpdateGroup($id: ID! $name: String!, $description: String) {
    updateGroup(id: $id, name: $name, description: $description) {
      ${GROUP_FIELDS}
    } 
  }
`

const makeUpdateGroupOptimisticResponse = ({ group, name }) => ({
  __typename: "Mutaton",
  updateGroup: {
    ...group,
    name,
  },
})

const useMutationUpdateGroup = () => useMutation(UPDATE_GROUP_MUTATION)

export { useMutationUpdateGroup, makeUpdateGroupOptimisticResponse }
